import { logOut, updateLocalStorageToken } from "../../../../containers/resources/utils";
import FlightService from "../../../../services/catalogs/FlightService";

export const REQUEST_DELETE_FLIGHT = "REQUEST_DELETE_FLIGHT";
export const DELETE_FLIGHT_SUCCESS = "DELETE_FLIGHT_SUCCESS";
export const DELETE_FLIGHT_ERROR = "DELETE_FLIGHT_ERROR";

function requestDeleteFlight() {
  return {
    type: REQUEST_DELETE_FLIGHT,
  };
}

function deleteFlightSuccess(json) {
  return {
    type: DELETE_FLIGHT_SUCCESS,
    message: json.data,
  };
}

function deleteFlightError(json) {
  return {
    type: DELETE_FLIGHT_ERROR,
    error: json.data,
  };
}

export function deleteFlight(flight_id) {
  return (dispatch) => {
    dispatch(requestDeleteFlight());
    return FlightService.deleteFlight(flight_id).then((json) => {
      if (json.data.code === 200) {
        dispatch(deleteFlightSuccess(json.data));
      } else if (json.data.code === 202) {
        updateLocalStorageToken(json.data.token);
        dispatch(deleteFlight(flight_id));
      } else if (json.data.code === 498) {
        logOut();
      } else {
        dispatch(deleteFlightError(json.data));
      }
    });
  };
}
